module["exports"] = [
  " s/n.",
  ", #",
  ", ##",
  " #",
  " ##",
  " ###",
  " ####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/building_number.js
// module id = 1207
// module chunks = 0